import { useEffect, useState } from 'react';
import { catPills, tickerNews } from '@/mocks/homeContent';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [query, setQuery] = useState('');
  const [activeCat, setActiveCat] = useState('事件专区');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="sticky top-0 z-50">
      {/* top utility strip */}
      <div className="bg-background-900 text-background-200">
        <div className="mx-auto flex max-w-[1240px] items-center justify-between px-4 py-1.5 text-xs md:px-6">
          <p className="flex items-center gap-2">
            <span className="inline-flex h-4 items-center rounded-sm bg-accent-500 px-1.5 font-label text-[11px] tracking-wide text-background-900">
              9黑料网
            </span>
            <span className="hidden text-background-300 sm:inline">分类专区聚合站 · 理性吃瓜阵地</span>
          </p>
          <div className="flex items-center gap-4">
            <a href="#faq" className="flex items-center gap-1 whitespace-nowrap text-background-200 transition hover:text-accent-300">
              <i className="ri-error-warning-line h-3.5 w-3.5 flex items-center justify-center" />纠错与异议
            </a>
            <a href="#ticker" className="hidden items-center gap-1 whitespace-nowrap text-background-200 transition hover:text-accent-300 md:flex">
              <i className="ri-flashlight-line h-3.5 w-3.5 flex items-center justify-center" />站长公告
            </a>
          </div>
        </div>
      </div>

      {/* main nav */}
      <div className={`transition-colors ${scrolled ? 'bg-background-50/95 shadow-sm backdrop-blur' : 'bg-background-100/90'}`}>
        <div className="mx-auto flex max-w-[1240px] items-center justify-between gap-4 px-4 py-3 md:px-6">
          {/* brand */}
          <a href="#top" className="group flex shrink-0 items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-label text-2xl text-background-50 transition group-hover:bg-primary-600">
              9
            </span>
            <span className="leading-none">
              <span className="block font-heading text-2xl font-black tracking-tight text-foreground-950">
                黑料<span className="text-primary-600">网</span>
              </span>
              <span className="mt-1 block text-[11px] tracking-widest text-foreground-500">分类聚合 · 专题整理</span>
            </span>
          </a>

          {/* category entry pills (desktop) */}
          <nav className="hidden items-center gap-1 lg:flex">
            {catPills.map((c) => (
              <a
                key={c.label}
                href={`#${c.label}`}
                onClick={() => setActiveCat(c.label)}
                className={`flex cursor-pointer flex-col items-center rounded-lg px-4 py-2 transition ${
                  activeCat === c.label ? 'bg-primary-500 text-background-50' : 'text-foreground-700 hover:bg-secondary-100'
                }`}
              >
                <span className="flex items-center gap-1 whitespace-nowrap text-sm font-bold">
                  <i className={`${c.icon} flex h-4 w-4 items-center justify-center`} />
                  {c.label}
                </span>
                <span className={`mt-0.5 text-[10px] ${activeCat === c.label ? 'text-background-100' : 'text-foreground-500'}`}>
                  {c.sub}
                </span>
              </a>
            ))}
          </nav>

          {/* actions */}
          <div className="flex shrink-0 items-center gap-2">
            <div className="hidden items-center gap-1 rounded-md bg-background-50 px-3 py-2 ring-1 ring-background-200 md:flex">
              <i className="ri-search-line flex h-4 w-4 items-center justify-center text-foreground-500" />
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜事件 / 人物 / 板块"
                className="w-32 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </div>
            <a
              href="#top"
              className="hidden whitespace-nowrap rounded-md bg-secondary-900 px-3.5 py-2 text-sm font-bold text-background-50 transition hover:bg-secondary-800 sm:block"
            >
              <i className="ri-quill-pen-line mr-1 flex h-4 w-4 items-center justify-center" />我要发帖
            </a>
            {/* hamburger */}
            <button
              type="button"
              aria-label="打开菜单"
              className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-900 ring-1 ring-background-200 lg:hidden"
            >
              <i className="ri-menu-3-line flex h-5 w-5 items-center justify-center" />
            </button>
          </div>
        </div>
      </div>

      {/* mobile category pills */}
      <div className="flex gap-2 overflow-x-auto px-4 pb-2 lg:hidden" style={{ scrollbarWidth: 'none' }}>
        {catPills.map((c) => (
          <a
            key={c.label}
            href={`#${c.label}`}
            onClick={() => setActiveCat(c.label)}
            className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-bold transition ${
              activeCat === c.label ? 'bg-primary-500 text-background-50' : 'bg-background-50 text-foreground-700 ring-1 ring-background-200'
            }`}
          >
            {c.label}
          </a>
        ))}
      </div>
    </div>
  );
}